/**
 * Řazení výpisu — pilulky místo dropdownu
 *
 * Převzato z www.abstore.cz (zadání klienta). Disco vykresluje řazení jako
 * tlačítko „Řadit podle:“ se skrytým panelem voleb; my panel rozložíme do
 * řady pilulek, aby byly volby vidět naráz. Tlačítka zůstávají Shoptetova
 * i s jeho obsluhou — měníme jen obal.
 *
 * Dělá čtyři věci:
 *   1. věší .listSorting--inline (vzhled řeší pages/category.scss),
 *   2. zjednodušuje počet položek na „7170 položek celkem“,
 *   3. dopisuje volbu „Skladem“ (order=stock), kterou Disco nenabízí,
 *   4. označuje zvolené řazení třídou --current podle ?order= v URL.
 *
 * Vzhled řeší CSS v pages/category.scss (.listSorting--inline).
 */
(function () {
	// Řazení, která se v liště nezobrazují. „Abecedně“ je u zboží
	// spíš matoucí než užitečné (stejně jako na referenci).
	var HIDDEN_SORTS = ['name'];

	// Volba, kterou Shoptet v nabídce nemá.
	var STOCK_SORT = { id: 'listSortingControl-stock', sort: 'stock', label: 'Skladem' };

	function currentOrder() {
		try {
			return new URLSearchParams(window.location.search).get('order') || '';
		} catch (e) {
			return '';
		}
	}

	// „Stránka 1 z 287 - 7170 položek celkem“ → „7170 položek celkem“.
	// Číslo stránky je nad výpisem k ničemu, stránkování je pod ním.
	function simplifyCount(header) {
		var pagination = header.querySelector('.category-header-pagination');
		if (!pagination || pagination.dataset.pestreSimplified) return;

		var totals = pagination.querySelectorAll('strong');
		if (!totals.length) return;

		var total = totals[totals.length - 1].textContent.trim();
		pagination.textContent = '';
		var strong = document.createElement('strong');
		strong.textContent = total;
		pagination.appendChild(strong);
		pagination.appendChild(document.createTextNode(' položek celkem'));
		pagination.dataset.pestreSimplified = '1';
	}

	// Volba „Skladem“ — URL se odvodí z kteréhokoli existujícího
	// tlačítka, aby zůstaly zachované ostatní parametry (filtry).
	function addStockSort(controls) {
		if (controls.querySelector('#' + STOCK_SORT.id)) return;

		var sample = controls.querySelector('.listSorting__control[data-url]');
		if (!sample) return;

		var url;
		try {
			url = new URL(sample.getAttribute('data-url'), window.location.origin);
			url.searchParams.set('order', STOCK_SORT.sort);
		} catch (e) {
			return;
		}

		var button = document.createElement('button');
		button.type = 'button';
		button.id = STOCK_SORT.id;
		button.className = 'listSorting__control';
		button.setAttribute('role', 'menuitem');
		button.setAttribute('data-sort', STOCK_SORT.sort);
		button.setAttribute('data-url', url.href);
		button.textContent = STOCK_SORT.label;

		// Tohle tlačítko Shoptet nezná, obsluhu si musí nést samo.
		button.addEventListener('click', function () {
			if (button.classList.contains('listSorting__control--current')) return;
			window.location.href = url.href;
		});

		controls.appendChild(button);
	}

	// Zvolené řazení podle ?order= v URL — jediného zdroje pravdy.
	// Shoptet sám žádnou třídu --current nevěší.
	//
	// Výchozí řazení („Doporučujeme“) záměrně nemá pilulku: Shoptet ho
	// nevykresluje jako tlačítko, jen jako text v přepínači. Bez
	// ?order= tak není zvýrazněná žádná volba — stejně jako na
	// referenci. Návrat k výchozímu řazení vede přes logo/kategorii.
	function markCurrent(controls) {
		var order = currentOrder();
		Array.prototype.forEach.call(controls.querySelectorAll('.listSorting__control'), function (control) {
			var isCurrent = control.getAttribute('data-sort') === order;
			control.classList.toggle('listSorting__control--current', isCurrent);
			if (isCurrent) {
				control.setAttribute('aria-disabled', 'true');
				control.setAttribute('aria-label', control.textContent.trim() + ' – aktuálně nastavené řazení');
			} else {
				control.removeAttribute('aria-disabled');
				control.removeAttribute('aria-label');
			}
		});
	}

	function hideSorts(controls) {
		HIDDEN_SORTS.forEach(function (sort) {
			var control = controls.querySelector('.listSorting__control[data-sort="' + sort + '"]');
			if (control) control.style.display = 'none';
		});
	}

	function init() {
		var header = document.getElementById('category-header');
		if (!header) return;

		simplifyCount(header);

		var sorting = header.querySelector('.listSorting');
		var controls = header.querySelector('#listSortingControls, .listSorting__controls');
		if (!sorting || !controls) return;

		sorting.classList.add('listSorting--inline');
		hideSorts(controls);
		addStockSort(controls);
		markCurrent(controls);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// Shoptet po filtrování překresluje výpis i hlavičku bez reloadu.
	document.addEventListener('ShoptetDOMPageContentLoaded', init);
})();
